module.exports = __webpack_public_path__ + "img/mySignatureEle.421dab38.svg";